import React from 'react';

import PurchaseRequisitionsIndex from '../../purchase_requisitions/PurchaseRequisitionsIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementPurchaseRequisitionsTab = () => {
    const { settings, routes } = useProcurement();

    return (
        <PurchaseRequisitionsIndex
            approvalStatuses={settings.approvalStatuses}
            pendingStatus={settings.pendingStatus}
            cancelledStatus={settings.cancelledStatus}
            eaEnabled={settings.isEaEnabled}
            indexUrlOpened={routes.fetchOpenedPurchaseRequisitions}
            indexUrlApproved={routes.fetchApprovedPurchaseRequisitions}
            indexUrlRejected={routes.fetchRejectedPurchaseRequisitions}
            indexUrlCancelled={routes.fetchCancelledPurchaseRequisitions}
            updateUrl={routes.updatePurchaseRequisitionUrl}
            deleteUrl={routes.deletePurchaseRequisitionUrl}
            toggleUrl={routes.togglePurchaseRequisitionUrl}
            createPurchaseOrderUrl={routes.createPurchaseOrderUrl}
        />
    );
};

export default ProcurementPurchaseRequisitionsTab;
